import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)
/**
 * Get all Wirecard info
 * @param {String} pdn
 * @param {String} startDate
 * @param {String} endDate
 */
export const getWirecardInfo = (
  pdn,
  startDate,
  endDate,
  authToken
) => {
  return req.get('/debitaccount/inquiry', {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn,
      startDate,
      endDate
    }
  })
}
